import { backdropClasses } from '@mui/material'
import { alpha, type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesBackdrop = (theme: Theme): ComponentsOverrides['MuiBackdrop'] => ({
  root: {
    backgroundColor: alpha(theme.customPalette.onElements.overlay ?? `${theme.customPalette.background.default}`, 0.7),
    backdropFilter: 'blur(2px)',
    [`&.${backdropClasses.invisible}`]: {
      backgroundColor: 'transparent',
      backdropFilter: 'none',
    },
  },
})
